import { supabase } from '@/integrations/supabase/client';
import { startOfWeek, endOfWeek, parseISO, differenceInHours } from 'date-fns';

interface ShiftData {
  id: string;
  start_date: string;
  end_date: string;
  assigned_guards: string[];
}

export const useShiftSwapValidation = () => {
  const validateSwap = async (
    requesterShift: ShiftData,
    targetShift: ShiftData,
    requesterGuardId: string,
    targetGuardId: string
  ): Promise<{ isValid: boolean; reason?: string }> => {
    // Check if shifts are in the same week
    const requesterStart = parseISO(requesterShift.start_date);
    const targetStart = parseISO(targetShift.start_date);
    
    const requesterWeekStart = startOfWeek(requesterStart, { weekStartsOn: 1 });
    const targetWeekStart = startOfWeek(targetStart, { weekStartsOn: 1 });
    
    if (requesterWeekStart.getTime() !== targetWeekStart.getTime()) {
      return { isValid: false, reason: 'Shifts must be in the same week (Monday-Sunday)' };
    }

    // Basic validation passed - admin will review for complex rules
    return { isValid: true };
  };

  return { validateSwap };
};
